// import styles from "./Gallery.module.scss";
import React from "react";
import _ from "lodash";

import Tac from "../../types/Tac";
import Guest from "../../types/Guest";
import TacFrame from "../TacFrame";

export interface GalleryTacProps {
    tac: Tac;
    guest: Guest;
    options: boolean;
    big: boolean;
    onHideOptions: () => void;
    onMaximize: () => void;
    onMouseOver: () => void;
    onClick: () => void;
    galleryID: number;
}

export interface GalleryProps {
    items: GalleryTacProps[];
    galleryID: number;
}

const GalleryTac = (props: GalleryTacProps) => {
    const signature = props.guest && props.guest.full_name;

    return (
        <li className="tac" onMouseLeave={props.onHideOptions}>
            {props.tac && props.tac.image && props.tac.image.optimized &&
                <TacFrame
                    tacID={props.tac.id}
                    galleryID={props.galleryID}
                    big={props.big}
                    renditions={props.tac.image.optimized}
                    filename={`${props.tac.id}.jpg`}
                    options={props.options}
                    onMaximize={props.onMaximize}
                    onMouseOver={props.onMouseOver}
                    onClick={props.onClick} />
            }
            {props.tac.note &&
                <p className="tac-note">{props.tac.note.text}</p>
            }
            {signature &&
                <p className="tac-signature">{signature}</p>
            }
        </li>
    );
};

export const Gallery = (props: GalleryProps) => {
    const items = _.map(props.items, (item: GalleryTacProps) => {
        return (
            <GalleryTac key={item.tac.name} {...item} galleryID={props.galleryID} />
        );
    });
    return (
        <div className="board-container">
            <ul className="tac-list">
                {items}
            </ul>
        </div>
    );
};

export default Gallery;
